import React, { useState, useEffect } from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { Tag, PersonAvatar } from '../Snippet';
import { useTranslation } from 'react-i18next'
import { useFormatter } from '../../utils';
import { Icon } from 'src/mtska-frontend-app-component/assets';

import JSONPretty from 'react-json-pretty';

const RelationshipCommissionInvoiceRow = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t, i18n } = useTranslation();
    const { formatDate } = useFormatter();
    const [rules, setRules] = useState();
    const tagcolors = {
        active: "success",
        terminated: "warning",
        future: "secondary",
        missing_timeframe: "danger"
    }

    return (
        <>
            <JSONPretty data={v} className={'json-wrapper'} /> 
            {rules && <ListItem key={k} variant="outlined" className={"relationship-element"}>
                <ListItemContent sx={{ display: 'flex' }} className={"relationship-element-content"}>
                    <Box className={"coupled"}>
                        <Box className="value production">
                            {v?.production}
                        </Box>
                    </Box>
                    <Box className={"coupled"}>
                        <Box className="label">{t('rules')}</Box>
                        <Box className="value">
                            {rules?.length ?? 0}
                        </Box>
                    </Box>
                    <Box className={"coupled"}>
                        <Box className="label">{t('match')}</Box>
                        <Box className="value">
                            {v?.matchingVehiclesCount ?? 0}
                        </Box>
                    </Box>

                    {
                        rules[0] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(rules[0]?.field)}>{t((rules[0]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(rules[0]?.operator)}</Box>
                            <Box className="label">{rules[0]?.value}</Box>
                        </Box>
                    }
                    {
                        rules[1] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(rules[1]?.field)}>{t((rules[1]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(rules[1]?.operator)}</Box>
                            <Box className="label">{rules[1]?.value}</Box>
                        </Box>
                    }
                    {
                        rules[2] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(rules[2]?.field)}>{t((rules[2]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(rules[2]?.operator)}</Box>
                            <Box className="label">{rules[2]?.value}</Box>
                        </Box>
                    }
                    {
                        rules[3] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(rules[3]?.field)}>{t((rules[3]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(rules[3]?.operator)}</Box>
                            <Box className="label">{rules[3]?.value}</Box>
                        </Box>
                    }
                    {
                        rules[4] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(rules[4]?.field)}>{t((rules[4]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(rules[4]?.operator)}</Box>
                            <Box className="label">{rules[4]?.value}</Box>
                        </Box>
                    }
                    {
                        rules[5] &&
                        <Box className={"tripled"}>
                            <Box className="label">{t(rules[5]?.field)}</Box>
                            <Box className="label operator">{t(rules[5]?.operator)}</Box>
                            <Box className="label">{rules[5]?.value}</Box>
                        </Box>
                    }
                </ListItemContent>
                {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
                {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
            </ListItem>
            }
        </>
    )
}

export default RelationshipCommissionInvoiceRow;



